import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Article = {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string;
  category: string;
  read_time: number;
  published_at: string;
  created_at: string;
  updated_at: string;
};

export type Category = {
  id: string;
  name: string;
  slug: string;
  description: string;
  created_at: string;
};

export type Profile = {
  id: string;
  full_name: string;
  created_at: string;
  updated_at: string;
};

export type Stock = {
  id: string;
  code: string;
  name: string;
  sector: string;
  price: number;
  prev_close: number;
  open_price: number;
  high: number;
  low: number;
  volume: number;
  market_cap: number;
  pe_ratio: number | null;
  pb_ratio: number | null;
  roe: number | null;
  der: number | null;
  avg_volume_20d: number;
  volume_ratio: number;
  broker_net_buy: number;
  foreign_net_buy: number;
  eps: number | null;
  eps_growth: number | null;
  revenue_growth: number | null;
  rsi: number | null;
  stoch_rsi: number | null;
  macd_signal: 'bullish' | 'bearish' | 'neutral';
  ma_20: number | null;
  ma_50: number | null;
  support: number | null;
  resistance: number | null;
  momentum_score: number;
  updated_at: string;
};

export type MarketIndex = {
  id: string;
  code: string;
  name: string;
  value: number;
  change: number;
  change_percent: number;
  updated_at: string;
};

export type Watchlist = {
  id: string;
  user_id: string;
  stock_code: string;
  created_at: string;
};

export type Portfolio = {
  id: string;
  user_id: string;
  stock_code: string;
  quantity: number;
  avg_price: number;
  created_at: string;
  updated_at: string;
};
